import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const manifestLink = document.querySelector('link[rel="manifest"]');
if (manifestLink) {
  manifestLink.remove();
}

const faviconLink = document.querySelector('link[rel="icon"]');
if (faviconLink) {
    faviconLink.remove();
}

document.title = "PlanMaster";

const theme = localStorage.getItem('theme') || 'dark';
if (theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
  document.documentElement.classList.add('dark')
} else {
  document.documentElement.classList.remove('dark')
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
